<template>
  <div class="order_detail">
    <nav-bar/>
    <search-bar/>
    <div class="main fz14" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/me/myorder' }"
              v-if="$route.query.type != 'finance'"
          >我的订单
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/me/finance' }" v-else>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order-list-item">产品信息</div>
            <div class="center order-list-item">产品规格</div>
            <div class="center order-list-item">设备信息</div>
            <div class="center order-list-item">产品价格</div>
            <div class="center order-list-item">数量</div>
            <div class="center order-list-item">小计</div>
            <div
                class="center order-list-item"
                v-show="order_detail.pay_state == '3' && order_detail.send_state == '4'"
            >操作
            </div>
          </div>
          <el-divider/>
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{ order_detail.create_time }}</span>
                <span class="ml20 grey">订单编号：{{ order_detail.order_no }}</span>
                <span class="ml40 blue" v-html="order_state_decide(order_detail)"></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                      class="fr jc ac order_left"
                      v-for="(goods,i) in order_detail.orderGoodsBeans"
                      :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                      <el-image class="goods_img fs mr10" :src="goods.goods_img" alt/>
                      <div>
                        <p class>{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
                        <table-column :info="goods"/>
                      </div>
                    </div>
                    <div class="center order-list-item">{{ specNameInit(goods) }}</div>
                    <div class="center order-list-item">{{ goods.device_id ? goods.device_id : '-' }}</div>

                    <div
                        class="center order-list-item"
                    >{{ order_detail.price_show ? "￥" + goods.goods_price : "-" }}
                    </div>
                    <div class="center order-list-item">{{ goods.goods_num }}</div>
                    <div
                        class="center order-list-item red"
                    >{{ order_detail.price_show ? "￥" + goods.goods_actual_price : "-" }}
                    </div>
                    <div
                        class="center order-list-item fc btns-success"
                        v-show="order_detail.pay_state == '3' && order_detail.send_state == '4'"
                    >
                      <p
                          class="blue cursor"
                          @click="go(`/orderevaluation?id=${order_detail.order_id}&goods_id=${goods.order_goods_id}`)"
                      >立即评价</p>
                      <p
                          class="grey cursor"
                          @click="go(`/feedback?id=${order_detail.order_id}&goods_id=${goods.order_goods_id}`)"
                      >质量反馈</p>
                    </div>
                  </div>
                </div>
              </div>

              <!--                下-->
              <div class="p20 fz14 bottom" style="text-align: right" v-if="order_detail.price_show">
                <div>
                  <span>订单金额</span>
                  <span class="blue">￥{{ order_detail.order_total_price }}</span>
                </div>
                <div class="mt10">
                  <span>已付款</span>
                  <span>￥{{ order_detail.pay_price }}</span>
                </div>
                <div class="mt10">
                  <span>未付款</span>
                  <span class="red">￥{{ sub(order_detail.order_actual_price, order_detail.pay_price) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="price_box">
          <div class="price_item fr ac jsb" v-if="false">
            <span class="black">商品价格</span>
            <span class="black">{{ goods_price }}</span>
          </div>
          <div class="price_item fr ac jsb" v-if="false">
            <span class="black">服务费</span>
            <span class="black">￥{{ order_detail.order_service_price }}</span>
          </div>

          <div class="price_item fr ac jsb mb20" v-if="false">
            <span class="black">订单总价</span>
            <span
                class="red bold"
            >{{ order_detail.price_show ? "￥" + order_detail.order_actual_price : "-" }}</span>
          </div>
          <div class="price_item fr ac jsb">
            <el-checkbox v-model="is_invoice" disabled>开具发票</el-checkbox>
            <div v-show="is_invoice">
              <span class="black">{{ invoice_json.invoice_name }}</span>
            </div>
          </div>
          <div class="price_item fr ac mb20" v-show="is_invoice">
            <span class="black">开票备注:</span>
            <el-input
                class="ml10"
                v-model="order_detail.invoice_remark"
                disabled
                style="width:30%"
                size="mini"
            />
          </div>
          <div class="price_item mb20">

            <el-form label-width="140px" class="pt20" style="width: 600px;">
              <el-form-item label="驳回原因：" v-show="order_detail.platform_sale_check_state === '-1'">
                <el-input v-model="order_detail.platform_sale_check_remarks" size="small" type="textarea" :rows="6"
                          resize="none" disabled></el-input>
              </el-form-item>
              <el-form-item label="驳回原因：" v-show="order_detail.contract_check_state === '-1'">
                <el-input v-model="order_detail.contract_check_remarks" size="small" type="textarea" :rows="6"
                          resize="none" disabled></el-input>
              </el-form-item>
              <el-form-item label="驳回原因：" v-show="order_detail.return_to_platform_sale_check_remarks">
                <el-input v-model="order_detail.return_to_platform_sale_check_remarks" size="small" type="textarea"
                          :rows="6"
                          resize="none" disabled></el-input>
              </el-form-item>
              <el-form-item label="客户内部订单号：">
                <el-input v-model="order_detail.vip_order_no" disabled style="width:100%" size="mini"/>
              </el-form-item>
              <el-form-item label="订单备注：">
                <el-input v-model="order_detail.order_remark" disabled style="width:100%" size="mini"/>
              </el-form-item>
              <el-form-item label="客户内部备注图片：">
                <up-load :file_list.sync="order_detail.vip_order_imgs" :disabled="true" :limit="6"/>
              </el-form-item>
            </el-form>

          </div>
          <!-- 付款比例 -->
          <p class="fz16 bold black mt20 mb20">付款方式</p>
          <div class="pay_table">
            <div class="tr fr">
              <div class="th fg fs">款到下单</div>
              <div class="th fg fs">款到发货</div>
              <div class="th fg fs">货到付款</div>
            </div>
            <div class="tr fr">
              <div class="td fg fs">
                <span>{{ order_detail.pay_start_price }}元</span>
                <div></div>
              </div>
              <div class="td fg fs">
                <span>{{ order_detail.pay_ing_price }}元</span>
                <div></div>
              </div>
              <div class="td fg fs fr ac jc">
                <span>{{ order_detail.pay_end_price }}元</span>
                <div class="ml20">
                  <span class="blue">{{ order_detail.pay_day }}天</span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      货到后须多少天内付款
                      <br/>例：30天，货到后须在30天内将剩余的60%付齐。
                    </div>

                    <i class="el-icon-warning-outline red"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <el-divider/>
          <!-- 收货地址 -->
          <p class="fz16 bold black  mt20 mb20">收货地址</p>
          <div class="receipt">
            <div class="top fr ac jsb">
              <div class="fr ac">
                <p>{{ address_json.address_name }}</p>
                <p class="ml20">{{ this.formatPhone(address_json.address_mobile) }}</p>
              </div>
              <!-- <el-button
                type="text"
                @click="addressvisible = true;"
                v-show="order_detail.platform_sale_check_state == '1' && order_detail.company_check2_state == '0' && order_detail.company_check_state == '1'"
              >修改</el-button>-->
            </div>
            <div class="bottom">
              {{ address_json.address_province }}
              {{ address_json.address_city }}
              {{ address_json.address_country }}
              {{ address_json.address_detailed }}
            </div>
          </div>
          <el-divider/>
          <!-- 采购合同 -->
          <template
              v-if="order_detail.contract_check_state == '1' && order_detail.platform_sale_check_state == '1'"
          >
            <div class="mt20 mb20 fr ac">
              <p class="fz14 bold black">采购合同</p>
            </div>
            <div class="mb20 ml20">
              <p class="mb20 bold">平台上传</p>
              <div class="fr fw">
                <up-load
                    :file_list.sync="order_detail.contract_platform_imgs.split(',')"
                    :limit="6"
                    :disabled="true"
                />
              </div>
            </div>
            <div class="mb20 ml20" v-show="contract_imgs.length">
              <p class="bold">我的上传</p>

              <div class="fr ac mb20 mt10">
                <up-load
                    :file_list.sync="contract_imgs"
                    :limit="6"
                    :disabled="contract_imgs.length > 0"
                />
              </div>
            </div>
          </template>
          <!-- 我的担保进来不显示操作 -->
          <div
              class="mt20 fr ac jc"
              v-if="$route.query.type != 'guar' && order_detail.company_check_state == '1'"
          >
            <!-- 待审核订单 -->
            <template v-if="order_detail.platform_sale_check_state == '0'">
              <el-button size="medium" @click="cancelOrder">取消订单</el-button>
            </template>
            <!-- <template
              v-if="order_detail.platform_sale_check_state == '1' && order_detail.company_check2_state == '0'"
            >
              <el-button size="medium" type="primary" @click="memberConfirmOrder">确认订单</el-button>
              <el-button size="medium" @click="cancel2Order">取消订单</el-button>
            </template>-->
            <!-- 待收货订单 -->
            <template
                v-if="order_detail.pay_state == '3' && order_detail.send_state == '2' || order_detail.pay_state == '3' && order_detail.send_state == '3'"
            >
              <el-button
                  size="medium"
                  type="primary"
                  @click="go(`/logistics?id=${order_detail.order_id}`)"
              >确认收货
              </el-button>
              <el-button size="medium" @click="go(`/logistics?id=${order_detail.order_id}`)">查看物流</el-button>
            </template>
            <!-- 已完成订单 -->
            <template v-if="order_detail.pay_state == '3' && order_detail.send_state == '4'">
              <el-button size="medium" @click="go(`/logistics?id=${order_detail.order_id}`)">查看物流</el-button>
              <el-button size="medium" type="primary" @click="repurchaseOrder">复购</el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <footer-bar/>
    <select-invoice :invoiceVisible.sync="invoiceVisible" @selectInvoice="selectInvoice"/>
    <select-address
        :address_id="Number(address_json.address_id)"
        :addressvisible.sync="addressvisible"
        @selectAddress="selectAddress"
    />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";
import SelectAddress from "@/components/SelectAddress";
import SelectInvoice from "@/components/SelectInvoice";

var timer = null;
export default {
  props: {},
  data() {
    return {
      order_detail: {},
      loading: false,
      invoiceVisible: false,
      addressvisible: false,
      contract_imgs: [],
      invoice_json: {},
      address_json: {},
      is_invoice: false
    };
  },
  computed: {
    goods_price() {
      if (!this.order_detail.price_show) return "-";
      let total = 0;
      if (!this.loading) return total;
      this.order_detail.orderGoodsBeans.forEach(el => {
        total = this.add(total, el.goods_total_price);
      });
      return "￥" + total;
    },
    craft_price() {
      let total = 0;
      if (!this.loading) return total;
      this.order_detail.orderGoodsBeans.forEach(el => {
        total = this.add(total, el.goods_craft_price);
      });
      return total;
    }
  },
  created() {
    this.getOrderDetail();
  },
  watch: {
    $route(n) {
      if (n.query.id) {
        this.getOrderDetail();
      }
    },
    "order_detail.vip_order_no"(n) {
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.updateOrder();
      }, 1000);
    },
    "order_detail.vip_order_imgs"(n) {
      this.updateOrder();
    },
    is_invoice(n) {
      if (n && this.is_Empty(this.invoice_json)) {
        this.getDefaultInvoice();
      }
    }
  },
  methods: {
    selectInvoice(row) {
      this.invoice_json = row;

      this.invoiceVisible = false;
    },

    selectAddress(row) {
      this.address_json = row;
    },
    // 上传内部单号，内部图片
    updateOrder() {
      this.post("orderInterfaces/v1.0/updateOrder", {
        order_id: this.order_detail.order_id,
        vip_order_no: this.order_detail.vip_order_no,
        vip_order_imgs: this.order_detail.vip_order_imgs.length
            ? this.order_detail.vip_order_imgs.join(",")
            : []
      });
    },
    // 取消订单
    cancelOrder() {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("orderInterfaces/v1.0/cancelOrder", {
              order_id: this.order_detail.order_id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getOrderDetail();
            });
          })
          .catch(() => {
          });
    },
    // 取消订单
    cancel2Order() {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("orderInterfaces/v1.0/companyCancel2Order", {
              order_id: this.order_detail.order_id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getOrderDetail();
            });
          })
          .catch(() => {
          });
    },
    // 确认订单
    memberConfirmOrder() {
      if (!this.contract_imgs.length) {
        this.$message({
          message: "请上传合同",
          type: "warning"
        });
        return;
      }
      let obj = {
        order_id: this.order_detail.order_id,
        contract_imgs: this.contract_imgs.join(","),
        vip_order_no: this.order_detail.vip_order_no,
        vip_order_imgs: this.order_detail.vip_order_imgs.length
            ? this.order_detail.vip_order_imgs.join(",")
            : [],
        address_json: JSON.stringify(this.address_json),
        is_invoice: this.is_invoice ? "1" : "0"
      };
      obj.order_remark = this.order_detail.order_remark;
      obj.invoice_json = "{}";
      if (this.is_invoice) {
        obj.invoice_json = JSON.stringify(this.invoice_json);
      }
      this.post("orderInterfaces/v1.0/memberConfirmOrder", obj).then(res => {
        this.$message({
          type: "success",
          message: res.data,
          duration: 3000
        });
        setTimeout(() => {
          this.back();
        }, 3000);
        this.getOrderDetail();
      });
    },
    // 获取默认发票
    getDefaultInvoice() {
      this.post("invoiceInterfaces/v1.0/getDefaultInvoice", {
        company_id: this.order_detail.company_id
      }).then(res => {
        this.invoice_json = res.data;
      });
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.is_invoice = res.data.is_invoice == "1";
        if (res.data.is_invoice == "1") {
          this.invoice_json = JSON.parse(
              JSON.stringify(res.data.orderInvoiceBean)
          );
        }
        this.address_json = JSON.parse(
            JSON.stringify(res.data.orderAddressBean)
        );
        this.order_detail = res.data;
        this.order_detail.price_show =
            res.data.platform_sale_check_state == "1" &&
            res.data.contract_check_state == "1";
        this.order_detail.vip_order_imgs = res.data.vip_order_imgs.length
            ? res.data.vip_order_imgs.split(",")
            : [];
        this.contract_imgs = res.data.contract_imgs.length
            ? res.data.contract_imgs.split(",")
            : [];
        this.loading = true;
      });
    },
    // 复购
    repurchaseOrder() {
      this.post("orderInterfaces/v1.0/repurchaseOrder", {
        order_id: this.order_detail.order_id
      }).then(res => {
        this.$message({
          type: "success",
          message: res.data
        });
        setTimeout(() => {
          this.go("/home/shopcart");
        }, 1000);
      });
    }
  },
  components: {
    NavBar,
    SearchBar,
    FooterBar,
    "up-load": Upload,
    "select-invoice": SelectInvoice,
    "select-address": SelectAddress
  }
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;

      .info {
        background-color: #fff;

        .order-list-item {
          height: 100%;
          flex-shrink: 0;

          &:nth-of-type(1) {
            width: 360px;
          }

          &:nth-of-type(2) {
            width: 150px;
          }

          &:nth-of-type(3) {
            width: 150px;
          }

          &:nth-of-type(4) {
            width: 160px;
          }

          &:nth-of-type(5) {
            width: 140px;
          }

          &:nth-of-type(6) {
            width: 128px;
            flex-grow: 1;
          }

          &:nth-of-type(7) {
            width: 70px;
          }
        }

        .btns-success {
          display: grid;
          grid-template-rows: repeat(2, 30px);
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  // border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .price_box {
        font-size: 14px;

        .price_item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #f0f6ff;
          border-bottom: 1px solid #fff;

          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }

        .pay_table {
          height: 100px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            .td {
              width: 33.33%;
            }
          }
        }

        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
        }

        .receipt {
          width: 40%;
          border: 1px solid #e5e5e5;

          .top {
            padding: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .bottom {
            padding: 30px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myorder/orderdetail.vue